export function isSp() {
  return $(window).width() < 768;
}
